export const rows = [
  {
    "id": 0,
    "Item": "citrus fruit",
    "Price": 8.71,
    "Quantity": 61,
    "Times_bought": 1800,
    "Item_revenue": 78.39,
    "Relations": "[['tropical fruit', 'citrus fruit', '3.0%'], ['whole milk', 'citrus fruit', '3.0%']]"
  },
  {
    "id": 1,
    "Item": "semi-finished bread",
    "Price": 18.49,
    "Quantity": 51,
    "Times_bought": 400,
    "Item_revenue": 36.98,
    "Relations": []
  },
  {
    "id": 2,
    "Item": "margarine",
    "Price": 7.64,
    "Quantity": 43,
    "Times_bought": 800,
    "Item_revenue": 30.56,
    "Relations": []
  },
  {
    "id": 3,
    "Item": "ready soups",
    "Price": 15.36,
    "Quantity": 42,
    "Times_bought": 200,
    "Item_revenue": 15.36,
    "Relations": []
  },
  {
    "id": 4,
    "Item": "tropical fruit",
    "Price": 6.35,
    "Quantity": 48,
    "Times_bought": 2400,
    "Item_revenue": 76.2,
    "Relations": "[['tropical fruit', 'citrus fruit', '3.0%'], ['yogurt', 'tropical fruit', '3.0%'], ['whole milk', 'tropical fruit', '3.0%'], ['other vegetables', 'tropical fruit', '4.0%'], ['rolls/buns', 'tropical fruit', '3.0%'], ['root vegetables', 'tropical fruit', '3.0%'], ['tropical fruit', 'brown bread', '3.0%']]"
  },
  {
    "id": 5,
    "Item": "yogurt",
    "Price": 3.31,
    "Quantity": 38,
    "Times_bought": 3000,
    "Item_revenue": 49.65,
    "Relations": "[['yogurt', 'tropical fruit', '3.0%'], ['yogurt', 'whole milk', '6.0%'], ['yogurt', 'cream cheese', '3.0%'], ['yogurt', 'bottled water', '3.0%'], ['yogurt', 'soda', '3.0%']]"
  },
  {
    "id": 6,
    "Item": "coffee",
    "Price": 7.13,
    "Quantity": 26,
    "Times_bought": 1400,
    "Item_revenue": 49.91,
    "Relations": []
  },
  {
    "id": 7,
    "Item": "whole milk",
    "Price": 10.73,
    "Quantity": 57,
    "Times_bought": 5000,
    "Item_revenue": 268.25,
    "Relations": "[['whole milk', 'citrus fruit', '3.0%'], ['whole milk', 'tropical fruit', '3.0%'], ['yogurt', 'whole milk', '6.0%'], ['other vegetables', 'whole milk', '7.0%'], ['butter', 'whole milk', '3.0%'], ['whole milk', 'rolls/buns', '3.0%'], ['curd', 'whole milk', '4.0%'], ['whole milk', 'soda', '4.0%'], ['sugar', 'whole milk', '3.0%'], ['pastry', 'whole milk', '3.0%'], ['root vegetables', 'whole milk', '4.0%'], ['whole milk', 'domestic eggs', '3.0%']]"
  },
  {
    "id": 8,
    "Item": "pip fruit",
    "Price": 14.99,
    "Quantity": 38,
    "Times_bought": 400,
    "Item_revenue": 29.98,
    "Relations": []
  },
  {
    "id": 9,
    "Item": "cream cheese",
    "Price": 8.64,
    "Quantity": 48,
    "Times_bought": 800,
    "Item_revenue": 34.56,
    "Relations": "[['yogurt', 'cream cheese', '3.0%']]"
  },
  {
    "id": 10,
    "Item": "meat spreads",
    "Price": 15.77,
    "Quantity": 25,
    "Times_bought": 400,
    "Item_revenue": 31.54,
    "Relations": []
  },
  {
    "id": 11,
    "Item": "other vegetables",
    "Price": 12.37,
    "Quantity": 91,
    "Times_bought": 3400,
    "Item_revenue": 210.29,
    "Relations": "[['other vegetables', 'tropical fruit', '4.0%'], ['other vegetables', 'whole milk', '7.0%'], ['other vegetables', 'rolls/buns', '5.0%'], ['other vegetables', 'bottled water', '3.0%'], ['other vegetables', 'root vegetables', '5.0%'], ['whipped/sour cream', 'other vegetables', '3.0%']]"
  },
  {
    "id": 12,
    "Item": "condensed milk",
    "Price": 13.7,
    "Quantity": 93,
    "Times_bought": 400,
    "Item_revenue": 27.4,
    "Relations": []
  },
  {
    "id": 13,
    "Item": "long life bakery product",
    "Price": 12.24,
    "Quantity": 35,
    "Times_bought": 400,
    "Item_revenue": 24.48,
    "Relations": []
  },
  {
    "id": 14,
    "Item": "butter",
    "Price": 13.61,
    "Quantity": 47,
    "Times_bought": 1200,
    "Item_revenue": 81.66,
    "Relations": "[['butter', 'whole milk', '3.0%']]"
  },
  {
    "id": 15,
    "Item": "rice",
    "Price": 17.51,
    "Quantity": 64,
    "Times_bought": 400,
    "Item_revenue": 35.02,
    "Relations": []
  },
  {
    "id": 16,
    "Item": "abrasive cleaner",
    "Price": 17.84,
    "Quantity": 99,
    "Times_bought": 400,
    "Item_revenue": 35.68,
    "Relations": []
  },
  {
    "id": 17,
    "Item": "rolls/buns",
    "Price": 0.24,
    "Quantity": 48,
    "Times_bought": 4200,
    "Item_revenue": 5.04,
    "Relations": "[['rolls/buns', 'tropical fruit', '3.0%'], ['whole milk', 'rolls/buns', '3.0%'], ['other vegetables', 'rolls/buns', '5.0%'], ['bottled water', 'rolls/buns', '4.0%'], ['rolls/buns', 'soda', '5.0%'], ['sugar', 'rolls/buns', '3.0%'], ['root vegetables', 'rolls/buns', '4.0%'], ['sausage', 'rolls/buns', '5.0%']]"
  },
  {
    "id": 18,
    "Item": "UHT-milk",
    "Price": 7.15,
    "Quantity": 71,
    "Times_bought": 400,
    "Item_revenue": 14.3,
    "Relations": []
  },
  {
    "id": 19,
    "Item": "bottled beer",
    "Price": 11.95,
    "Quantity": 89,
    "Times_bought": 600,
    "Item_revenue": 35.85,
    "Relations": []
  },
  {
    "id": 20,
    "Item": "liquor (appetizer)",
    "Price": 19.64,
    "Quantity": 74,
    "Times_bought": 200,
    "Item_revenue": 19.64,
    "Relations": []
  },
  {
    "id": 21,
    "Item": "potted plants",
    "Price": 18.54,
    "Quantity": 52,
    "Times_bought": 200,
    "Item_revenue": 18.54,
    "Relations": []
  },
  {
    "id": 22,
    "Item": "cereals",
    "Price": 13.4,
    "Quantity": 43,
    "Times_bought": 400,
    "Item_revenue": 26.8,
    "Relations": []
  },
  {
    "id": 23,
    "Item": "white bread",
    "Price": 2.35,
    "Quantity": 76,
    "Times_bought": 200,
    "Item_revenue": 2.35,
    "Relations": []
  },
  {
    "id": 24,
    "Item": "bottled water",
    "Price": 7.69,
    "Quantity": 49,
    "Times_bought": 2400,
    "Item_revenue": 92.28,
    "Relations": "[['yogurt', 'bottled water', '3.0%'], ['other vegetables', 'bottled water', '3.0%'], ['bottled water', 'rolls/buns', '4.0%']]"
  },
  {
    "id": 25,
    "Item": "chocolate",
    "Price": 4.27,
    "Quantity": 61,
    "Times_bought": 1200,
    "Item_revenue": 25.62,
    "Relations": []
  },
  {
    "id": 26,
    "Item": "curd",
    "Price": 12.9,
    "Quantity": 93,
    "Times_bought": 1200,
    "Item_revenue": 77.4,
    "Relations": "[['curd', 'whole milk', '4.0%']]"
  },
  {
    "id": 27,
    "Item": "flour",
    "Price": 7.04,
    "Quantity": 100,
    "Times_bought": 600,
    "Item_revenue": 21.12,
    "Relations": []
  },
  {
    "id": 28,
    "Item": "dishes",
    "Price": 9.1,
    "Quantity": 87,
    "Times_bought": 200,
    "Item_revenue": 9.1,
    "Relations": []
  },
  {
    "id": 29,
    "Item": "beef",
    "Price": 12.22,
    "Quantity": 39,
    "Times_bought": 800,
    "Item_revenue": 48.88,
    "Relations": []
  },
  {
    "id": 30,
    "Item": "frankfurter",
    "Price": 4.42,
    "Quantity": 53,
    "Times_bought": 600,
    "Item_revenue": 13.26,
    "Relations": []
  },
  {
    "id": 31,
    "Item": "soda",
    "Price": 8.82,
    "Quantity": 52,
    "Times_bought": 2600,
    "Item_revenue": 114.66,
    "Relations": "[['yogurt', 'soda', '3.0%'], ['whole milk', 'soda', '4.0%'], ['rolls/buns', 'soda', '5.0%'], ['pastry', 'soda', '3.0%']]"
  },
  {
    "id": 32,
    "Item": "chicken",
    "Price": 18.14,
    "Quantity": 85,
    "Times_bought": 400,
    "Item_revenue": 36.28,
    "Relations": []
  },
  {
    "id": 33,
    "Item": "sugar",
    "Price": 5.41,
    "Quantity": 75,
    "Times_bought": 1400,
    "Item_revenue": 37.87,
    "Relations": "[['sugar', 'whole milk', '3.0%'], ['sugar', 'rolls/buns', '3.0%']]"
  },
  {
    "id": 34,
    "Item": "fruit/vegetable juice",
    "Price": 5.36,
    "Quantity": 92,
    "Times_bought": 1800,
    "Item_revenue": 48.24,
    "Relations": "[['fruit/vegetable juice', 'brown bread', '3.0%']]"
  },
  {
    "id": 35,
    "Item": "newspapers",
    "Price": 17.97,
    "Quantity": 85,
    "Times_bought": 1800,
    "Item_revenue": 161.73,
    "Relations": []
  },
  {
    "id": 36,
    "Item": "packaged fruit/vegetables",
    "Price": 8.93,
    "Quantity": 71,
    "Times_bought": 400,
    "Item_revenue": 17.86,
    "Relations": []
  },
  {
    "id": 37,
    "Item": "specialty bar",
    "Price": 2.03,
    "Quantity": 57,
    "Times_bought": 600,
    "Item_revenue": 6.09,
    "Relations": []
  },
  {
    "id": 38,
    "Item": "butter milk",
    "Price": 17.52,
    "Quantity": 71,
    "Times_bought": 800,
    "Item_revenue": 70.08,
    "Relations": []
  },
  {
    "id": 39,
    "Item": "pastry",
    "Price": 0.34,
    "Quantity": 59,
    "Times_bought": 1800,
    "Item_revenue": 3.06,
    "Relations": "[['pastry', 'whole milk', '3.0%'], ['pastry', 'soda', '3.0%']]"
  },
  {
    "id": 40,
    "Item": "processed cheese",
    "Price": 13.22,
    "Quantity": 100,
    "Times_bought": 400,
    "Item_revenue": 26.44,
    "Relations": []
  },
  {
    "id": 41,
    "Item": "detergent",
    "Price": 14.92,
    "Quantity": 91,
    "Times_bought": 1200,
    "Item_revenue": 89.52,
    "Relations": []
  },
  {
    "id": 42,
    "Item": "root vegetables",
    "Price": 18.38,
    "Quantity": 77,
    "Times_bought": 1800,
    "Item_revenue": 165.42,
    "Relations": "[['root vegetables', 'tropical fruit', '3.0%'], ['root vegetables', 'whole milk', '4.0%'], ['other vegetables', 'root vegetables', '5.0%'], ['root vegetables', 'rolls/buns', '4.0%']]"
  },
  {
    "id": 43,
    "Item": "frozen dessert",
    "Price": 13.06,
    "Quantity": 60,
    "Times_bought": 200,
    "Item_revenue": 13.06,
    "Relations": []
  },
  {
    "id": 44,
    "Item": "sweet spreads",
    "Price": 1.08,
    "Quantity": 50,
    "Times_bought": 200,
    "Item_revenue": 1.08,
    "Relations": []
  },
  {
    "id": 45,
    "Item": "salty snack",
    "Price": 8.54,
    "Quantity": 73,
    "Times_bought": 600,
    "Item_revenue": 25.62,
    "Relations": []
  },
  {
    "id": 46,
    "Item": "waffles",
    "Price": 0.74,
    "Quantity": 46,
    "Times_bought": 600,
    "Item_revenue": 2.22,
    "Relations": []
  },
  {
    "id": 47,
    "Item": "candy",
    "Price": 12.16,
    "Quantity": 37,
    "Times_bought": 400,
    "Item_revenue": 24.32,
    "Relations": []
  },
  {
    "id": 48,
    "Item": "bathroom cleaner",
    "Price": 9.86,
    "Quantity": 90,
    "Times_bought": 400,
    "Item_revenue": 19.72,
    "Relations": []
  },
  {
    "id": 49,
    "Item": "canned beer",
    "Price": 9.55,
    "Quantity": 89,
    "Times_bought": 1600,
    "Item_revenue": 76.4,
    "Relations": "[['canned beer', 'brown bread', '3.0%'], ['shopping bags', 'canned beer', '3.0%']]"
  },
  {
    "id": 50,
    "Item": "sausage",
    "Price": 1.73,
    "Quantity": 60,
    "Times_bought": 1600,
    "Item_revenue": 13.84,
    "Relations": "[['sausage', 'rolls/buns', '5.0%']]"
  },
  {
    "id": 51,
    "Item": "brown bread",
    "Price": 17.17,
    "Quantity": 67,
    "Times_bought": 1400,
    "Item_revenue": 120.19,
    "Relations": "[['tropical fruit', 'brown bread', '3.0%'], ['fruit/vegetable juice', 'brown bread', '3.0%'], ['canned beer', 'brown bread', '3.0%']]"
  },
  {
    "id": 52,
    "Item": "shopping bags",
    "Price": 12.08,
    "Quantity": 94,
    "Times_bought": 600,
    "Item_revenue": 36.24,
    "Relations": "[['shopping bags', 'canned beer', '3.0%']]"
  },
  {
    "id": 53,
    "Item": "beverages",
    "Price": 0.98,
    "Quantity": 31,
    "Times_bought": 400,
    "Item_revenue": 1.96,
    "Relations": []
  },
  {
    "id": 54,
    "Item": "hamburger meat",
    "Price": 9.8,
    "Quantity": 40,
    "Times_bought": 600,
    "Item_revenue": 29.4,
    "Relations": []
  },
  {
    "id": 55,
    "Item": "spices",
    "Price": 11.27,
    "Quantity": 92,
    "Times_bought": 200,
    "Item_revenue": 11.27,
    "Relations": []
  },
  {
    "id": 56,
    "Item": "hygiene articles",
    "Price": 7.18,
    "Quantity": 48,
    "Times_bought": 400,
    "Item_revenue": 14.36,
    "Relations": []
  },
  {
    "id": 57,
    "Item": "napkins",
    "Price": 5.97,
    "Quantity": 67,
    "Times_bought": 400,
    "Item_revenue": 11.94,
    "Relations": []
  },
  {
    "id": 58,
    "Item": "pork",
    "Price": 16.6,
    "Quantity": 66,
    "Times_bought": 600,
    "Item_revenue": 49.8,
    "Relations": "[['whipped/sour cream', 'pork', '3.0%']]"
  },
  {
    "id": 59,
    "Item": "berries",
    "Price": 17.57,
    "Quantity": 37,
    "Times_bought": 1200,
    "Item_revenue": 105.42,
    "Relations": []
  },
  {
    "id": 60,
    "Item": "whipped/sour cream",
    "Price": 14.4,
    "Quantity": 69,
    "Times_bought": 1000,
    "Item_revenue": 72,
    "Relations": "[['whipped/sour cream', 'other vegetables', '3.0%'], ['whipped/sour cream', 'pork', '3.0%']]"
  },
  {
    "id": 61,
    "Item": "artif. sweetener",
    "Price": 3.19,
    "Quantity": 86,
    "Times_bought": 200,
    "Item_revenue": 3.19,
    "Relations": []
  },
  {
    "id": 62,
    "Item": "grapes",
    "Price": 18.57,
    "Quantity": 83,
    "Times_bought": 600,
    "Item_revenue": 55.71,
    "Relations": []
  },
  {
    "id": 63,
    "Item": "dessert",
    "Price": 0.94,
    "Quantity": 91,
    "Times_bought": 200,
    "Item_revenue": 0.94,
    "Relations": []
  },
  {
    "id": 64,
    "Item": "zwieback",
    "Price": 3.72,
    "Quantity": 59,
    "Times_bought": 200,
    "Item_revenue": 3.72,
    "Relations": []
  },
  {
    "id": 65,
    "Item": "domestic eggs",
    "Price": 13.86,
    "Quantity": 67,
    "Times_bought": 800,
    "Item_revenue": 55.44,
    "Relations": "[['whole milk', 'domestic eggs', '3.0%']]"
  },
  {
    "id": 66,
    "Item": "spread cheese",
    "Price": 4.65,
    "Quantity": 80,
    "Times_bought": 200,
    "Item_revenue": 4.65,
    "Relations": []
  },
  {
    "id": 67,
    "Item": "misc. beverages",
    "Price": 15.08,
    "Quantity": 52,
    "Times_bought": 200,
    "Item_revenue": 15.08,
    "Relations": []
  },
  {
    "id": 68,
    "Item": "hard cheese",
    "Price": 16.09,
    "Quantity": 66,
    "Times_bought": 400,
    "Item_revenue": 32.18,
    "Relations": []
  },
  {
    "id": 69,
    "Item": "cat food",
    "Price": 0.26,
    "Quantity": 52,
    "Times_bought": 400,
    "Item_revenue": 0.52,
    "Relations": []
  },
  {
    "id": 70,
    "Item": "ham",
    "Price": 12.13,
    "Quantity": 49,
    "Times_bought": 400,
    "Item_revenue": 24.26,
    "Relations": []
  },
  {
    "id": 71,
    "Item": "turid",
    "Price": 7.89,
    "Quantity": 65,
    "Times_bought": 200,
    "Item_revenue": 7.89,
    "Relations": []
  },
  {
    "id": 72,
    "Item": "baking powder",
    "Price": 15.36,
    "Quantity": 84,
    "Times_bought": 200,
    "Item_revenue": 15.36,
    "Relations": []
  },
  {
    "id": 73,
    "Item": "pickled vegetables",
    "Price": 5.69,
    "Quantity": 77,
    "Times_bought": 400,
    "Item_revenue": 11.38,
    "Relations": []
  },
  {
    "id": 74,
    "Item": "oil",
    "Price": 9.31,
    "Quantity": 64,
    "Times_bought": 1000,
    "Item_revenue": 46.55,
    "Relations": []
  },
  {
    "id": 75,
    "Item": "chewing gum",
    "Price": 5.42,
    "Quantity": 42,
    "Times_bought": 200,
    "Item_revenue": 5.42,
    "Relations": []
  },
  {
    "id": 76,
    "Item": "chocolate marshmallow",
    "Price": 17.52,
    "Quantity": 81,
    "Times_bought": 200,
    "Item_revenue": 17.52,
    "Relations": []
  },
  {
    "id": 77,
    "Item": "ice cream",
    "Price": 12.8,
    "Quantity": 85,
    "Times_bought": 200,
    "Item_revenue": 12.8,
    "Relations": []
  },
  {
    "id": 78,
    "Item": "frozen vegetables",
    "Price": 3.09,
    "Quantity": 96,
    "Times_bought": 800,
    "Item_revenue": 12.36,
    "Relations": []
  },
  {
    "id": 79,
    "Item": "canned fish",
    "Price": 4.7,
    "Quantity": 59,
    "Times_bought": 200,
    "Item_revenue": 4.7,
    "Relations": []
  },
  {
    "id": 80,
    "Item": "seasonal products",
    "Price": 8.69,
    "Quantity": 64,
    "Times_bought": 200,
    "Item_revenue": 8.69,
    "Relations": []
  },
  {
    "id": 81,
    "Item": "curd cheese",
    "Price": 19.43,
    "Quantity": 99,
    "Times_bought": 200,
    "Item_revenue": 19.43,
    "Relations": []
  },
  {
    "id": 82,
    "Item": "red/blush wine",
    "Price": 2.57,
    "Quantity": 39,
    "Times_bought": 600,
    "Item_revenue": 7.71,
    "Relations": []
  },
  {
    "id": 83,
    "Item": "frozen potato products",
    "Price": 17.22,
    "Quantity": 29,
    "Times_bought": 400,
    "Item_revenue": 34.44,
    "Relations": []
  },
  {
    "id": 84,
    "Item": "specialty fat",
    "Price": 0.38,
    "Quantity": 81,
    "Times_bought": 200,
    "Item_revenue": 0.38,
    "Relations": []
  },
  {
    "id": 85,
    "Item": "specialty chocolate",
    "Price": 9.68,
    "Quantity": 98,
    "Times_bought": 400,
    "Item_revenue": 19.36,
    "Relations": []
  },
  {
    "id": 86,
    "Item": "candles",
    "Price": 13.5,
    "Quantity": 80,
    "Times_bought": 600,
    "Item_revenue": 40.5,
    "Relations": []
  },
  {
    "id": 87,
    "Item": "flower (seeds)",
    "Price": 3.56,
    "Quantity": 52,
    "Times_bought": 200,
    "Item_revenue": 3.56,
    "Relations": []
  },
  {
    "id": 88,
    "Item": "sparkling wine",
    "Price": 16.36,
    "Quantity": 100,
    "Times_bought": 200,
    "Item_revenue": 16.36,
    "Relations": []
  },
  {
    "id": 89,
    "Item": "salt",
    "Price": 15.43,
    "Quantity": 34,
    "Times_bought": 400,
    "Item_revenue": 30.86,
    "Relations": []
  },
  {
    "id": 90,
    "Item": "frozen meals",
    "Price": 19.11,
    "Quantity": 40,
    "Times_bought": 200,
    "Item_revenue": 19.11,
    "Relations": []
  },
  {
    "id": 91,
    "Item": "canned vegetables",
    "Price": 8.35,
    "Quantity": 89,
    "Times_bought": 200,
    "Item_revenue": 8.35,
    "Relations": []
  },
  {
    "id": 92,
    "Item": "onions",
    "Price": 15.55,
    "Quantity": 40,
    "Times_bought": 600,
    "Item_revenue": 46.65,
    "Relations": []
  },
  {
    "id": 93,
    "Item": "herbs",
    "Price": 4.09,
    "Quantity": 45,
    "Times_bought": 200,
    "Item_revenue": 4.09,
    "Relations": []
  },
  {
    "id": 94,
    "Item": "white wine",
    "Price": 19.19,
    "Quantity": 29,
    "Times_bought": 200,
    "Item_revenue": 19.19,
    "Relations": []
  },
  {
    "id": 95,
    "Item": "brandy",
    "Price": 1.12,
    "Quantity": 56,
    "Times_bought": 200,
    "Item_revenue": 1.12,
    "Relations": []
  },
  {
    "id": 96,
    "Item": "photo/film",
    "Price": 3.11,
    "Quantity": 39,
    "Times_bought": 200,
    "Item_revenue": 3.11,
    "Relations": []
  },
  {
    "id": 97,
    "Item": "sliced cheese",
    "Price": 6.82,
    "Quantity": 35,
    "Times_bought": 200,
    "Item_revenue": 6.82,
    "Relations": []
  },
  {
    "id": 98,
    "Item": "pasta",
    "Price": 8.16,
    "Quantity": 97,
    "Times_bought": 200,
    "Item_revenue": 8.16,
    "Relations": []
  }
];